// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608101439/js/" + chunkId + "." + {"44":"121f9178","225":"6c10c387","481":"5da11e9c","486":"04ce33fa","770":"11322024"}[chunkId] + ".0.7781006455995519.chunk.js";
};